import React from 'react'

const NotFoundPage: React.FC = () => (
    <div>
        <h1>Page not found</h1>
    </div>
)

export default NotFoundPage
